import { Box, Text } from '@wix/design-system';
import classNames from 'classnames';

import useIsArticlePageRedesignUnifiedUXEnabled from '../../../../hooks/useIsArticlePageRedesignUnifiedUXEnabled';
import { MessageSender } from '../MessageSender';

import css from './index.module.scss';

type ChatMessageProps = {
  message: string;
};

export const ChatMessage = ({ message }: ChatMessageProps) => {
  const isCopilotRedesign = useIsArticlePageRedesignUnifiedUXEnabled();

  return (
    <Box direction="vertical" gap="2" className={css.chatMessageContainer}>
      <MessageSender />
      <Box
        className={classNames(css.message, {
          [css.copilotRedesign]: isCopilotRedesign,
        })}
      >
        <Text size="medium">{message}</Text>
      </Box>
    </Box>
  );
};
